<template>
    <div class="text-black pr-3 pl-3">
        <AppPushNotification ref="notification" :title="notificationModel.title" :text="notificationModel.text"
            :color="notificationModel.color" />
        <div>
            <Header></Header>
            <Banner @update-cartTotal="updateCartTotal"></Banner>
            <RecommendProducts @update-cartTotal="updateCartTotal"></RecommendProducts>
            <AppMenulists ref="appMenulists"></AppMenulists>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/util/util'
import '@/util/menu.css'
import Header from '@/components/AppHeader'
import Banner from '@/components/AppBanners'
import RecommendProducts from '@/components/AppRecommendProducts'
import AppMenulists from '@/components/AppMenulists'
import pos from '@/services/pos'
import AppPushNotification from '@/components/AppPushNotification.vue'
import moment from 'moment'

export default {
    components: {
        AppMenulists,
        RecommendProducts,
        Header,
        Banner,
        AppPushNotification,
        isProfileLoaded: false
    },
    data() {
        return {
            cartLists: [],
            cartTotal: [],
            notificationModel: {
                title: '',
                text: '',
                color: '',
            },
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll)
    },
    computed: {
        ...mapGetters(['shopLineOA']),
        uid() {
            return `${localStorage.getItem('uid')}`
        },
        shopObjectId() {
            return `${localStorage.getItem('shopObjectId')}`
        },
        shop() {
            return this.shopLineOA.find(
                (detail) => detail.objectId === this.shopObjectId
            )
        },
        shopName() {
            if (this.shop) {
                return this.shop.shopName
            } else {
                return ''
            }
        },
        logo() {
            if (this.shop) {
                return this.shop.remoteImagePath
            } else {
                return ''
            }
        },
        noImg() {
            return process.env.VUE_APP_NOIMAGE
        },
    },
    beforeCreate() {
        localStorage.removeItem('receiptObjectId');
        ['profileObjectId', 'token', 'refreshToken'].forEach(key => {
            const value = this.$route.query[key];
            if (value) localStorage.setItem(key, value);
        });
    },
    async created() {
        this.getCartTotal()
        await this.getUserProfile()
        await this.verifyOrderAble()
    },
    methods: {
        ...util,
        async getUserProfile() {
            try {
                // const phone = localStorage.getItem('phone')
                const profileObjectId = localStorage.getItem('profileObjectId') || this.$route.query.profileObjectId
                const uid = localStorage.getItem('uid')
                const res = await pos({
                    url: `/api/v1.3/${uid}/profile?objectId=${profileObjectId}`,
                    method: 'get',
                    headers: {
                        token: localStorage.getItem('token') || this.$route.query.token
                    }
                })
                if (res.data?.error?.code == 0) {
                    const profile = res.data.data
                    localStorage.setItem('profile', JSON.stringify(profile))
                    localStorage.setItem('profileObjectId', profile.objectId)

                    // 🔥 FIX: map member ตรงนี้เลย
                    await this.safeMapMember(profile.objectId)

                } else if (res.data.error.code == 402) {
                    this.renewToken()
                } else if (res.data.error.code == 4000) {
                    this.logOut()
                }
            } catch (error) {
                console.error(error);
            }
        },
        async safeMapMember(profileObjectId) {
            if (!profileObjectId) return

            // รอ shopLineOA พร้อม
            if (!this.shop?.objectId) {
                console.warn('shop not ready, wait...')
                return
            }

            try {
                await pos({
                url: `/api/v1.3/${this.uid}/profile/member`,
                method: 'post',
                headers: {
                    token: localStorage.getItem('token')
                },
                data: {
                    profileObjectId,
                    shop: {
                    objectId: this.shop.objectId,
                    id: this.shop.id,
                    branchName: this.shop.branchName,
                    }
                }
                })
                console.log('✅ mapMember success')
            } catch (e) {
                console.error('❌ mapMember failed', e)
            }
        },
        async renewToken() {
            try {
                if (localStorage.getItem('refreshToken')) {
                    const refreshToken = localStorage.getItem('refreshToken')

                    let res = {}
                    res = await pos({
                        url: `/auth/v1.0/renewtoken/otp`,
                        method: 'post',
                        data: {
                            "refreshToken": refreshToken
                        }
                    });
                    if (res.data?.error?.code == 0) {
                        localStorage.setItem('token', res.data?.data?.token)
                        // window.location.reload()
                    } else {
                        this.logOut()
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        logOut() {
            const uid = localStorage.getItem('uid')
            const shopObjectId = localStorage.getItem('shopObjectId')
            sessionStorage.clear()
            localStorage.clear()
            localStorage.setItem('uid', uid)
            localStorage.setItem('shopObjectId', shopObjectId)
            this.$router.push('/delivery/home')
        },
        trackButtonClick(buttonLabel) {
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'click', {
                    event_label: buttonLabel,
                });
            } else {
                console.error('gtag is not defined.');
            }
        },
        updateCartTotal(total) {
            this.$refs.appMenulists.updateCartTotal(total)
            this.cartTotal = total
            this.$emit('update-cartTotal', total)
            this.$forceUpdate()
        },
        updateTotalCost() {
            this.cartLists = JSON.parse(sessionStorage.getItem('cart')) || []
            let total = this.cartLists.reduce((accum, product) => {
                return accum + product.totalAmount
            }, 0)

            this.totalCost = util.convertCurrency(total)
            this.componentKey += 1
        },
        getCartTotal() {
            let total = this.cartLists.reduce((accum, product) => {
                return accum + product.quantity
            }, 0)

            this.cartTotal = total
        },
        showNotification(title, text, color) {
            this.notificationModel = {
                color: color,
                title: title,
                text: text,
            }
            if (this.$refs.notification) {
                this.$refs.notification.pushNotification();
            }

        },
        async verifyOrderAble() {
            try {
                const shopObjectId = `${localStorage.getItem('shopObjectId')}`;
                const response = await pos({
                    method: 'get',
                    url: '/api/v3.0/shop/order/able',
                    headers: {
                        shopObjectId: shopObjectId,
                    }
                });
                const isAble = response.data?.data?.success || false;
                if (!isAble) {
                    let kitchenTime = JSON.parse(localStorage.getItem('kitchenTime'));
                    const today = moment().format('ddd');
                    const todaySchedule = kitchenTime[today];
                    if (todaySchedule) {
                        const { openTime, closeTime, closed } = todaySchedule;
                        if (closed) {
                            this.showNotification(this.$i18n.t('shopIsClosedToday'), '', 'warning');
                        } else {
                            let text = `${this.$i18n.t('openAt')} ${openTime} - ${closeTime}`;
                            this.showNotification(this.$i18n.t('restaurantIsCurrentlyClosed'), text, 'warning');
                        }
                    } else {
                        console.warn('No kitchen schedule found for today.');
                    }
                }
            } catch (error) {
                console.error('Error calling the orderAble API:', error);
            }
        },

        async mapMember() {
            try {
                const uid = localStorage.getItem('uid')
                const token = localStorage.getItem('token')
                const profileObjectId = localStorage.getItem('profileObjectId')

                const resMember = await pos({
                    url: `/api/v1.3/${uid}/profile/member`,
                    method: 'post',
                    data: {
                        profileObjectId: profileObjectId,
                        shop: {
                            objectId: this.shop.objectId,
                            id: this.shop.id,
                            branchName: this.shop.branchName,
                        }
                    },
                    headers: {
                        authorization: token
                    }
                })
                if (resMember.data.error.code == 0) {
                    console.log('Created Profile and Added Member Success')
                }
            } catch (error) {
                console.error(error)
            }
        },
        async updateProfileLanguege(objectId) {
            const uid = localStorage.getItem('uid')
            const token = localStorage.getItem('token')

            const data = {
                objectId: objectId,
                language: this.$i18n.locale
            }
            await pos({
                url: `/api/v1.3/${uid}/profile/languege`,
                method: 'patch',
                data: data,
                headers: {
                    authorization: token
                },
            })
        }
    },

}
</script>
